import { createSlice } from "@reduxjs/toolkit";

// 🔐 Safe JWT decode
const parseJwt = (token) => {
  try {
    if (!token) return null;

    const parts = token.split(".");
    if (parts.length !== 3) return null;

    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(base64));
  } catch (err) {
    console.error("JWT decode failed:", err);
    return null;
  }
};

const initialState = {
  user: null,
  tokens: null,
  expiry: null,
  unreadCount: 0,
  location: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,

  reducers: {
    setUser: (state, action) => {
      state.user = action.payload || null;
    },

    setTokens: (state, action) => {
      const tokens = action.payload;

      state.tokens = tokens || null;
      state.expiry = null;

      const accessToken = tokens?.accessToken;
      if (!accessToken) return;

      const decoded = parseJwt(accessToken);

      if (decoded?.exp) {
        state.expiry = decoded.exp * 1000; // sec → ms
      } else {
        console.warn("⚠️ JWT missing exp");
      }
    },

    clearAuth: (state) => {
      state.user = null;
      state.tokens = null;
      state.expiry = null;
      state.unreadCount = 0;
      state.location = null;
    },

    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload || 0;
    },

    setLocation: (state, action) => {
      state.location = action.payload;
    },
  },
});

export const {
  setUser,
  setTokens,
  clearAuth,
  setUnreadCount,
  setLocation,
} = userSlice.actions;

export default userSlice.reducer;